import { createFileRoute } from '@tanstack/react-router';
import { requireFeature } from '@portal/platform/guards';
import { BuilderPage } from '@/features/template-builder/builder-page';

/**
 * The email template builder. Its own lazy chunk (with the editor and tiptap): the router splits
 * every route. The list route checks `template-tyres:read`.
 */
export const Route = createFileRoute('/_app/email-templates/builder')({
  staticData: { featureKey: 'template-builder-email' },
  beforeLoad: ({ context, location }) =>
    requireFeature(context, location, {
      feature: 'template-builder-email',
      permissions: ['template-tyres:read'],
    }),
  component: () => <BuilderPage kind="email" />,
});
